import defaultWebWireTransferInstructions from '#themes/default/web/components/wireTransferInstructions/wireTransferInstructions.js';

import cCopyLine from '#themes/avast/web/components/copyLine/copyLine.js';
import cInfoBox from '#themes/avast/web/components/infoBox/infoBox.js';
import cInstructionStep from '#themes/avast/web/components/instructionStep/instructionStep.js';
import cOfflineContentBox from '#themes/avast/web/components/offlineContentBox/offlineContentBox.js';
import cQrCode from '#themes/avast/web/components/qrCode/qrCode.js';

export default {
	components: {
		cCopyLine,
		cInfoBox,
		cInstructionStep,
		cOfflineContentBox,
		cQrCode
	},
	extends: defaultWebWireTransferInstructions
};
